import { TableButtonsEnum } from '@enums/table-custom.enum';
import { Component, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-group-buttons',
  templateUrl: './group-buttons.component.html',
  styleUrls: ['./group-buttons.component.scss']
})
export class GroupButtonsComponent implements OnInit {

  @Input() buttons: any;
  @Input() itemDataSource: any;
  tableButtonsEnum = TableButtonsEnum;

  constructor(
    private _render: Renderer2,
  ) { }

  ngOnInit(): void {
  }

  showButtonsAction(event) {
    if (event && event.target && event.target.offsetParent && event.target.offsetParent.nextSibling && event.target.offsetParent.nextSibling.classList && event.target.offsetParent.nextSibling.classList.contains('show')) {
      this._render.removeClass(event.target.offsetParent.nextSibling, 'show');
    } else {
      this._render.addClass(event.target.offsetParent.nextSibling, 'show');
    }
  }

}
